import { createFeature, createReducer, on } from "@ngrx/store";
import { CompanyReport, ReportFilter } from "../models/report.models";
import { ReportsActions } from "./reports.actions";

export interface ReportsState {
    reports: CompanyReport[];
    clientId: string;
    query: string;
    filter: ReportFilter;
    pageSize: number;
    pageIndex: number;
    pageTokens: string[];
    nextToken: string | null;
    loading: boolean;
    loaded: boolean;
    error: boolean;
    downloadingId: string | null;
    downloadError: boolean;
}

const initialState: ReportsState = {
    reports: [],
    clientId: "",
    query: "",
    filter: "all",
    pageSize: 10,
    pageIndex: 0,
    pageTokens: [""],
    nextToken: null,
    loading: false,
    loaded: false,
    error: false,
    downloadingId: null,
    downloadError: false,
};

export const reportsFeature = createFeature({
    name: "reports",
    reducer: createReducer(
        initialState,
        on(
            ReportsActions.pageOpened,
            (state, { clientId }): ReportsState => ({
                ...initialState,
                clientId,
                loading: true,
            })
        ),
        on(
            ReportsActions.pageRequested,
            (state): ReportsState => ({
                ...state,
                loading: true,
                error: false,
            })
        ),
        on(
            ReportsActions.pageLoaded,
            (state, { reports, nextToken, token, pageIndex }): ReportsState => {
                const pageTokens = [...state.pageTokens];
                pageTokens[pageIndex] = token;
                return {
                    ...state,
                    reports,
                    nextToken,
                    pageIndex,
                    pageTokens,
                    loading: false,
                    loaded: true,
                    error: false,
                };
            }
        ),
        on(
            ReportsActions.pageLoadFailed,
            (state): ReportsState => ({
                ...state,
                loading: false,
                loaded: true,
                error: true,
            })
        ),
        on(
            ReportsActions.queryChanged,
            (state, { query }): ReportsState => ({ ...state, query })
        ),
        on(
            ReportsActions.filterChanged,
            (state, { filter }): ReportsState => ({ ...state, filter })
        ),
        on(
            ReportsActions.downloadRequested,
            (state, { report }): ReportsState => ({
                ...state,
                downloadingId: report.id,
                downloadError: false,
            })
        ),
        on(
            ReportsActions.downloadSucceeded,
            (state): ReportsState => ({ ...state, downloadingId: null })
        ),
        on(
            ReportsActions.downloadFailed,
            (state): ReportsState => ({
                ...state,
                downloadingId: null,
                downloadError: true,
            })
        ),
        on(
            ReportsActions.downloadStatusCleared,
            (state): ReportsState => ({ ...state, downloadError: false })
        )
    ),
});
